import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchDatabaseTables } from '@/features/asset-detail';
import type { TablesResponse } from '@/features/asset-detail';

export const useTables = (databaseSchemaFqn: string, includeDeleted: boolean = false, enabled: boolean = true) => {
  return useQuery<TablesResponse | null>({
    queryKey: assetKeys.databaseTables(databaseSchemaFqn, includeDeleted),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchDatabaseTables(databaseSchemaFqn, includeDeleted);
    },
    enabled: enabled && !!databaseSchemaFqn,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
